import { render, staticRenderFns } from "./InstanceLeftMenuAction.vue?vue&type=template&id=24684326&scoped=true"
import script from "./InstanceLeftMenuAction.vue?vue&type=script&lang=js"
export * from "./InstanceLeftMenuAction.vue?vue&type=script&lang=js"
import style0 from "./InstanceLeftMenuAction.vue?vue&type=style&index=0&id=24684326&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24684326",
  null
  
)

export default component.exports